import styled from '@emotion/styled';
import { RobotoFont } from '../../styles/fonts';

export const Container = styled.div`
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  color: #e5e6e7;
  display: flex;
  align-items: center;
  line-height: 20px;
  background-color: #0d0d0e;

  .privacy-policy {
    font-family: ${RobotoFont.style.fontFamily}, sans-serif;
    font-style: normal;
    font-weight: 450;
    font-size: 18px;
    line-height: 30px;
    letter-spacing: '-.75px';
    cursor: pointer;
  }

  .privacy-policy:hover {
    text-decoration: underline;
  }

  @media only screen and (min-width: 768px) {
    min-height: 50px;
    font-size: 22px;
    .privacy-policy {
      font-size: 18px;
    }
  }
`;

export const BannerStyles: React.CSSProperties = {
  backgroundColor: '#0d0d0e',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const ButtonStyles = {
  backgroundColor: 'rgba(0, 0, 0, 0)',
  color: 'white',
  padding: '12px 52px',
  fontSize: '15px',
  fontWeight: 400,
  fontFamily: `${RobotoFont.style.fontFamily}, sans-serif`,
  lineHeight: '20px',
  border: '1px solid white',
  borderRadius: '2px',
  letterSpacing: '2px',
  '@media only screen and (minWidth: 768px)': {
    fontSize: '22px',
    padding: '12px 24px',
  },
  marginRight: '24px',
};
